import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';

function Stock() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('0');
    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    const [totalopbal, setTotalopbal] = useState(0);
    const [totalp, setTotalp] = useState(0);
    const [totalprtn, setTotalprtn] = useState(0);
    const [totals, setTotals] = useState(0);
    const [totalsrtn, setTotalsrtn] = useState(0);
    const [totalstin, setTotalsint] = useState(0);
    const [totalstout, setTotalstout] = useState(0);
    const [totalrpl, setTotalrpl] = useState(0);
    const [totalcls, setTotalcls] = useState(0);
    const [totalstkval, setTotalstkval] = useState(0);
    const [totalsalval, setTotalsalval] = useState(0);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };


    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItemOption, setSelectedItemOption] = useState(null);

    const handleItemChange = (newValue) => newValue;
    const fetchItemOptions = async (inputValue = '') => {
        // Early return if input value is empty or too short
        if (!inputValue || inputValue.length <= 1) {
            return [];
        }


        try {
            // Fetch data from the API            
            const response = await fetchData('PurchaseOrderApi', `/Item/${companyId}/${branchId}/${inputValue}`, token);

            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                // Ensure the response data is an array
                if (Array.isArray(data)) {
                    setItemsrOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.ItemName1,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };

    const [ItemId, setItem] = useState('0');
    const handleChangeDrop = (selectedOption) => {
        setSelectedItemOption(selectedOption);
        const ItemId = selectedOption?.value || '0';
        setItem(ItemId);
        setDataItem([]);
    };


    const hasReadReportPermission = permissions.includes('Read Reports');
    const [loading, setLoading] = useState(false);

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([]);
            setLoading(true);

            try {
                const response = await fetchData('ReportApi', `/Stock/${companyId}/${branchId}/${ItemId}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Stock Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };



    const handleExportExcel = () => {
        const wb = XLSX.utils.book_new();

        // Create a sheet with all data (without grouping)
        const allDataSheet = [];
        const allDataHeaderCaption = [`Stock From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
        allDataSheet.push(allDataHeaderCaption);

        // Adding header row
        const headerRow = ['Item', 'Batch Number', 'Opening', 'Purchase', 'Purchase Return', 'Sale', 'Sale Return', 'Closing'];
        allDataSheet.push(headerRow);

        // Extracting data for the Excel sheet
        groupedData.forEach((group) => {
            // Push the group total row
            const dataGroupRow = [
                group.name,
                "", // Empty for batch number
                group.total.OpeningQty,
                group.total.PurchaseQty,
                group.total.PurchaseReturnQty,
                group.total.SaleQty,
                group.total.SaleReturnQty,
                group.total.ClosingQty,
            ];
            allDataSheet.push(dataGroupRow);

            // Push each batch item for the group
            group.batches.forEach((data) => {
                const batchRow = [
                    "", // Empty for item name
                    data.BatchNumber,
                    data.OpeningQty,
                    data.PurchaseQty,
                    data.PurchaseReturnQty,
                    data.SaleQty,
                    data.SaleReturnQty,
                    data.ClosingQty,
                ];
                allDataSheet.push(batchRow);
            });
        });

        // Add grand total row
        const totalRowAll = ['Total', '', grandTotal.OpeningQty, grandTotal.PurchaseQty, grandTotal.PurchaseReturnQty, grandTotal.SaleQty, grandTotal.SaleReturnQty, grandTotal.ClosingQty];
        allDataSheet.push(totalRowAll);

        // Creating the worksheet
        const allDataWs = XLSX.utils.aoa_to_sheet(allDataSheet);
        XLSX.utils.book_append_sheet(wb, allDataWs, 'Stock');

        // Export the Excel file
        XLSX.writeFile(wb, 'Stock.xlsx');
    };


    const groupDataByNameAndBatch = (data) => {
        const groupedData = {};
        const grandTotal = {
            OpeningQty: 0,
            PurchaseQty: 0,
            PurchaseReturnQty: 0,
            SaleQty: 0,
            SaleReturnQty: 0,
            ClosingQty: 0,
        };

        data.forEach((item) => {
            const key = item.Name;

            if (!groupedData[key]) {
                groupedData[key] = {
                    name: item.Name,
                    total: { ...item }, // Store total for this name
                    batches: [],
                };
            } else {
                // Sum numerical fields at the name level
                groupedData[key].total.OpeningQty += item.OpeningQty;
                groupedData[key].total.PurchaseQty += item.PurchaseQty;
                groupedData[key].total.PurchaseReturnQty += item.PurchaseReturnQty;
                groupedData[key].total.SaleQty += item.SaleQty;
                groupedData[key].total.SaleReturnQty += item.SaleReturnQty;
                groupedData[key].total.ClosingQty += item.ClosingQty;
            }

            // Sum up the grand total
            grandTotal.OpeningQty += item.OpeningQty;
            grandTotal.PurchaseQty += item.PurchaseQty;
            grandTotal.PurchaseReturnQty += item.PurchaseReturnQty;
            grandTotal.SaleQty += item.SaleQty;
            grandTotal.SaleReturnQty += item.SaleReturnQty;
            grandTotal.ClosingQty += item.ClosingQty;

            // Store batch-wise data
            groupedData[key].batches.push(item);
        });

        return { groupedData: Object.values(groupedData), grandTotal };
    };

    const { groupedData, grandTotal } = groupDataByNameAndBatch(filteredDataItem);

    return (

        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bolder' }}>
                CONSOLIDATED STOCK
            </h6>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>

                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    {loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )}

                    <div className="w-4/5 mr-2 flex items-center" style={{ marginTop: '0.75%' }}>
                        <label
                            className="block uppercase tracking-wide text-black text-xs font-bold mr-2"
                            htmlFor="Weightage"
                        >
                            Item Name
                        </label>
                        <AsyncSelect
                            cacheOptions
                            loadOptions={fetchItemOptions}
                            onInputChange={handleItemChange}
                            onChange={handleChangeDrop}
                            value={selectedItemOption}
                            className="flex-grow"
                        />
                    </div>

                    <Button
                        //style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        style={{
                            background: 'linear-gradient(to right, #C7FFD8,#C7FFD8)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: '#0F0F0F',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '15px',
                            marginTop: '15px'
                        }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >

                        <span>Refresh</span>
                    </Button>
                    <Button
                        //style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        style={{
                            background: 'linear-gradient(to right, #98DED9,#98DED9)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: '#0F0F0F',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '10px',
                            marginTop: '15px'
                        }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >

                        <span>Excel</span>
                    </Button>


                </div>
                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        From 
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        To 
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
            </div>


            <div
                className="w-full mb-5 flex"
                style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}
            >
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#08396B', width: '2500px' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#D8D9CF', borderBottom: '1px solid #ddd', fontSize: '14px', color: 'black', padding: '5px', fontWeight: 'bold' }}>Item</TableCell>
                                <TableCell sx={{ backgroundColor: '#D8D9CF', borderBottom: '1px solid #ddd', fontSize: '14px', color: 'black', padding: '5px', fontWeight: 'bold' }}>Batch Number</TableCell>
                                <TableCell sx={{ backgroundColor: '#D8D9CF', borderBottom: '1px solid #ddd', fontSize: '14px', color: 'black', textAlign: 'right', padding: '5px', fontWeight: 'bold' }}>Opening</TableCell>
                                <TableCell sx={{ backgroundColor: '#D8D9CF', borderBottom: '1px solid #ddd', fontSize: '14px', color: 'black', textAlign: 'right', padding: '5px', fontWeight: 'bold' }}>Purchase</TableCell>
                                <TableCell sx={{ backgroundColor: '#D8D9CF', borderBottom: '1px solid #ddd', fontSize: '14px', color: 'black', textAlign: 'right', padding: '5px', fontWeight: 'bold' }}>Purchase Return</TableCell>
                                <TableCell sx={{ backgroundColor: '#D8D9CF', borderBottom: '1px solid #ddd', fontSize: '14px', color: 'black', textAlign: 'right', padding: '5px', fontWeight: 'bold' }}>Sale</TableCell>
                                <TableCell sx={{ backgroundColor: '#D8D9CF', borderBottom: '1px solid #ddd', fontSize: '14px', color: 'black', textAlign: 'right', padding: '5px', fontWeight: 'bold' }}>Sale Return</TableCell>
                                <TableCell sx={{ backgroundColor: '#D8D9CF', borderBottom: '1px solid #ddd', fontSize: '14px', color: 'black', textAlign: 'right', padding: '5px', fontWeight: 'bold' }}>Closing</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {groupedData.map((group, index) => (
                                <React.Fragment key={index}>
                                    {/* Render the first row with Name and total */}
                                    <TableRow sx={{ backgroundColor: '#cce5ff', height: '40px' }}>
                                        <TableCell
                                            sx={{ fontWeight: 'bold', fontSize: '14px', padding: '5px', color: '#08396B' }}
                                            colSpan={2}
                                        >
                                            {group.name}
                                        </TableCell>
                                        {[group.total.OpeningQty, group.total.PurchaseQty, group.total.PurchaseReturnQty, group.total.SaleQty, group.total.SaleReturnQty, group.total.ClosingQty].map((value, i) => (
                                            <TableCell
                                                key={i}
                                                sx={{ textAlign: 'right', fontWeight: 'bold', fontSize: '14px', padding: '5px', color: '#08396B' }}
                                            >
                                                {value}
                                            </TableCell>
                                        ))}
                                    </TableRow>

                                    {/* Render batch-wise data */}
                                    {group.batches.map((data, batchIndex) => (
                                        <TableRow key={batchIndex} sx={{ backgroundColor: 'white', height: '35px' }}>
                                            <TableCell sx={{ padding: '5px' }} /> {/* Empty cell for Name */}
                                            <TableCell sx={{ fontSize: '13px', padding: '5px', fontWeight: 'bold', color: '#555' }}>
                                                {data.BatchNumber}
                                            </TableCell>
                                            {[data.OpeningQty, data.PurchaseQty, data.PurchaseReturnQty, data.SaleQty, data.SaleReturnQty, data.ClosingQty].map((value, i) => (
                                                <TableCell
                                                    key={i}
                                                    sx={{ textAlign: 'right', fontSize: '12px', fontWeight: 'bold', padding: '5px', color: '#333' }}
                                                >
                                                    {value}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </React.Fragment>
                            ))}

                            {/* Grand Total Row */}
                            <TableRow sx={{ backgroundColor: 'teal', height: '45px' }}>
                                <TableCell
                                    colSpan={2}
                                    sx={{ fontWeight: 'bold', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}
                                >
                                    Total
                                </TableCell>
                                {[grandTotal.OpeningQty, grandTotal.PurchaseQty, grandTotal.PurchaseReturnQty, grandTotal.SaleQty, grandTotal.SaleReturnQty, grandTotal.ClosingQty].map((value, i) => (
                                    <TableCell
                                        key={i}
                                        sx={{ textAlign: 'right', fontWeight: 'bold', fontSize: '14px', padding: '5px', color: 'whitesmoke' }}
                                    >
                                        {value}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableBody>



                    </Table>
                </TableContainer>

            </div>

        </div>
    );
}

export default Stock;
